/** Capitalizes the first letter of a string, lowercases the rest. */
export function capitalize(s: string): string {
  return s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : '';
}

/** Formats a byte count as a human-readable string using SI units (1000-based). */
export function formatBytes(value: number): string {
  const abs = Math.abs(value);
  if (abs >= 1_000_000_000) return `${(value / 1_000_000_000).toFixed(2)} GB`;
  if (abs >= 1_000_000)     return `${(value / 1_000_000).toFixed(2)} MB`;
  if (abs >= 1_000)         return `${(value / 1_000).toFixed(2)} KB`;
  return `${value.toFixed(2)} B`;
}
